import { useAuthStore } from "@/store/auth-store";
import { useViewStore } from "@/store/view-store";
import { Button } from "@heroui/button";
import { IconUserCircle } from "@tabler/icons-react";
import { useTranslations } from "../../i18n";
import React from "react";

function UserMenu() {
  const t = useTranslations("auth");
  const { navigate } = useViewStore();
  const { isAuthenticated } = useAuthStore();

  return (
    <div>
      {isAuthenticated ? (
        <Button
          variant="ghost"
          color="primary"
          onPress={() => navigate("profile")}
          startContent={<IconUserCircle />}
        >
          {t("profile")}
        </Button>
      ) : (
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            color="primary"
            onPress={() => navigate("login")}
          >
            {t("login")}
          </Button>
          <Button
            variant="solid"
            color="primary"
            onPress={() => navigate("login")}
          >
            {t("register")}
          </Button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
